import {createLazyFileRoute} from '@tanstack/react-router'

import OrderDetails from '@/views/Account/Orders/OrderDetails'

export const Route = createLazyFileRoute('/_account/orders/$orderId/')({
  component: OrderDetails,
})
